// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

label.inputLabel {
  padding-left: 0;
}

.inputfile + button {
  display: inline-block;
  background-color: #a4a4a4;
}
.inputfile + button:hover,
.inputfile + button:focus {
  background-color: #a4a4a4;
}

.inputfile ~ .inputfilePath {
  display: inline-block;
  width: 74%;
  padding-top: 9px;
  padding-bottom: 10px;
  padding-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/fileInput.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB","sourcesContent":[".inputfile {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n\nlabel.inputLabel {\n  padding-left: 0;\n}\n\n.inputfile + button {\n  display: inline-block;\n  background-color: #a4a4a4;\n}\n.inputfile + button:hover,\n.inputfile + button:focus {\n  background-color: #a4a4a4;\n}\n\n.inputfile ~ .inputfilePath {\n  display: inline-block;\n  width: 74%;\n  padding-top: 9px;\n  padding-bottom: 10px;\n  padding-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
